import React from "react";
import styled from "styled-components";
import { Checkbox, CheckboxProps } from "../Checkbox";

/**
 * A specialized checkbox component for use in Table cells
 */
export const TableCheckbox = styled(Checkbox)`
  margin-bottom: 0;
  margin-right: 12px;

  [role="label"] {
    display: none;
  }
`;

/**
 * Props for TableCheckbox component
 */
export interface TableCheckboxProps extends CheckboxProps {
  /**
   * Optional additional class name
   */
  className?: string;
}

export default TableCheckbox;
